// Mock data for Hurghada Excursions Landing Page

export const excursions = [
  {
    id: 1,
    name: "Orange Bay",
    description: "Plage paradisiaque aux eaux cristallines",
    price: "À partir de 35€",
    image: "https://images.pexels.com/photos/1591373/pexels-photo-1591373.jpeg"
  },
  {
    id: 2,
    name: "Paradise Island",
    description: "Île tropicale avec snorkeling inclus",
    price: "À partir de 30€",
    image: "https://images.pexels.com/photos/2869654/pexels-photo-2869654.jpeg"
  },
  {
    id: 3,
    name: "Journée dauphins en mer",
    description: "Nagez avec les dauphins en Mer Rouge",
    price: "À partir de 40€",
    image: "https://images.pexels.com/photos/3354346/pexels-photo-3354346.jpeg"
  },
  {
    id: 4,
    name: "Safari Quad / Safari combiné",
    description: "Aventure dans le désert égyptien",
    price: "À partir de 25€",
    image: "https://images.pexels.com/photos/5098033/pexels-photo-5098033.jpeg"
  },
  {
    id: 5,
    name: "Louxor 1 jour",
    description: "Découvrez les temples antiques",
    price: "À partir de 85€",
    image: "https://images.pexels.com/photos/35433016/pexels-photo-35433016.jpeg"
  }
];

export const packages = [
  {
    id: 1,
    name: "Package Découverte Mer Rouge",
    includes: ["Orange Bay", "Journée dauphins en mer", "Snorkeling journée bateau"],
    price: "À partir de 95€",
    popular: true
  },
  {
    id: 2,
    name: "Package Aventure & Sensations",
    includes: ["Safari Quad / combiné", "Journée dauphins", "Paradise Island"],
    price: "À partir de 85€",
    popular: false
  },
  {
    id: 3,
    name: "Package Culture & Incontournables",
    includes: ["Louxor 1 jour", "Orange Bay", "Snorkeling bateau"],
    price: "À partir de 140€",
    popular: false
  }
];

export const testimonials = [
  {
    id: 1,
    name: "M. Marie",
    rating: 5,
    text: "Super expérience ! Maxime s'est occupé de tout très simplement via WhatsApp. Aucune prise de tête, tout était clair et fluide du début à la fin."
  },
  {
    id: 2,
    name: "J. Jean-Pierre",
    rating: 5,
    text: "Franchement rassurant d'avoir enfin un contact français sur place. Maxime est réactif, de bon conseil, et les excursions étaient vraiment au top pour le prix."
  },
  {
    id: 3,
    name: "S. Sophie",
    rating: 5,
    text: "Orange Bay était juste magnifique 😍 Maxime a répondu à toutes mes questions et tout s'est déroulé exactement comme prévu."
  },
  {
    id: 4,
    name: "L. Laurent",
    rating: 5,
    text: "Le safari quad était incroyable ! Organisation nickel, horaires respectés, aucune mauvaise surprise. Merci Maxime pour le suivi."
  },
  {
    id: 5,
    name: "I. Isabelle",
    rating: 5,
    text: "Je voyageais avec mes enfants et tout était parfaitement adapté. Maxime a pris le temps de me rassurer et de m'expliquer chaque détail. Je recommande sans hésiter."
  }
];

export const faqData = [
  {
    question: "Comment réserver une excursion ou un pack ?",
    answer: "La réservation se fait directement sur le site en quelques secondes. Tu choisis ton excursion ou ton pack, tu règles un acompte sécurisé, puis je te contacte immédiatement sur WhatsApp pour confirmer tous les détails."
  },
  {
    question: "Le paiement en ligne est-il sécurisé ?",
    answer: "Oui. Tous les paiements en ligne sont 100 % sécurisés via Stripe, l'une des plateformes de paiement les plus fiables au monde. Tes informations bancaires ne sont jamais stockées sur mon site."
  },
  {
    question: "Dois-je payer la totalité à l'avance ?",
    answer: "Non. Tu paies uniquement un acompte au moment de la réservation. Le solde est à régler sur place le jour de l'excursion, sans frais cachés."
  },
  {
    question: "Que se passe-t-il après le paiement de l'acompte ?",
    answer: "Une fois l'acompte payé, je te contacte directement sur WhatsApp pour confirmer la disponibilité, l'horaire exact et organiser la prise en charge depuis ton hôtel. Tu as toujours un contact humain francophone."
  },
  {
    question: "Puis-je poser des questions avant de réserver ?",
    answer: "Oui. Tu peux me contacter à tout moment sur WhatsApp, avant ou après la réservation. Je réponds rapidement et clairement à toutes tes questions."
  },
  {
    question: "Que se passe-t-il en cas d'annulation ?",
    answer: "En cas d'annulation suffisamment à l'avance, je trouve toujours une solution : report de date ou annulation selon la situation. Ta tranquillité est ma priorité."
  },
  {
    question: "Les transferts depuis l'hôtel sont-ils inclus ?",
    answer: "Oui. La prise en charge depuis ton hôtel à Hurghada est incluse pour toutes les excursions et packs, sauf indication contraire sur la page de l'activité."
  },
  {
    question: "Les excursions sont-elles adaptées aux enfants ?",
    answer: "Oui, la majorité de mes excursions sont adaptées aux familles et aux enfants. Si une activité nécessite un âge minimum ou des conditions particulières, cela est toujours précisé."
  },
  {
    question: "Suis-je accompagné par un guide francophone ?",
    answer: "Pour certaines excursions culturelles (Louxor, Le Caire), un guide francophone est inclus. Pour les autres activités, je reste disponible en français via WhatsApp avant et pendant l'excursion."
  }
];

// FAQ courte pour mobile (5 questions essentielles)
export const faqMobileData = [
  {
    question: "Le paiement est-il sécurisé ?",
    answer: "Oui, le paiement de l'acompte est sécurisé via Stripe."
  },
  {
    question: "Dois-je payer tout à l'avance ?",
    answer: "Non, uniquement un acompte. Le solde se règle sur place."
  },
  {
    question: "Vais-je être contacté après réservation ?",
    answer: "Oui, je te contacte immédiatement sur WhatsApp après le paiement."
  },
  {
    question: "Le transfert hôtel est-il inclus ?",
    answer: "Oui, sauf mention contraire sur la page de l'activité."
  },
  {
    question: "Puis-je poser mes questions avant ?",
    answer: "Oui, tu peux m'écrire à tout moment sur WhatsApp."
  }
];

// Note: whatsappLink is deprecated, use getGenericWhatsAppLink() from utils/whatsapp.js instead
export const whatsappLink = "https://wa.me/201221948907?text=Bonjour%2C%20je%20souhaite%20des%20informations%20sur%20les%20excursions%20%C3%A0%20Hurghada";
